export default {"src":"/_next/static/image/components/ui/Icon/icons/user.9b8d11c57c52fbe713d75c2eed720c1b.svg","height":20,"width":20};